jQuery('document').ready(function onEventListReady($) {
    "use strict";

    $('.events__list .events__list-see-all').on('click', onClickSeeAllEvents);

    function onClickSeeAllEvents(e) {
        e.preventDefault();
        $('.events__list li.invisible').slideDown();
        $('.events__list .events__list-see-all').fadeOut('fast');
    }
});